import { ChangeOwnerComponentProps, ChangeOwnerField } from 'app/area/favourite-administration/list/change-owner/types';

export const hasFieldValueChanged = (prevProps: ChangeOwnerComponentProps, props: ChangeOwnerComponentProps) => {
  const previousForm = prevProps?.list?.changeOwner?.form ?? {};
  const currentForm = props?.list?.changeOwner?.form ?? {};

  return Object.keys(ChangeOwnerField)
    .some(field => currentForm[field] !== previousForm[field]);
};

export const allFieldsEmpty = (props: ChangeOwnerComponentProps) =>
  !props?.list?.changeOwner?.form?.[ChangeOwnerField.owner];

export const isDisabled = (props: ChangeOwnerComponentProps) => {
  const changeOwnerFields = Object.keys(ChangeOwnerField);
  const changeOwner = props?.list?.changeOwner;
  const fieldsError = changeOwner?.validation
    && changeOwnerFields.map(item => changeOwner?.form[item] && changeOwner?.validation[item]).filter(f => !!f);

  return fieldsError?.length > 0 && !changeOwner?.isDirty;
};
